<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex w-100 justify-content-between align-items-center">
          <h1 class="labelBold">
            {{ this.$t(`qrAccess.activeDrivers.title`) }}
          </h1>
          <button
            @click="downloadTable"
            class="btn-download mr-5"
          >{{ $t("events.listEvents.donwloadBtn") }}</button>
          <!-- <button class="btn-download mr-5">
            {{ $t("events.listEvents.donwloadBtn") }}
          </button> -->
        </div>

        <router-link
          class=""
          :to="{
            name: 'New Driver',
            params: {
              create: true
            }
          }"
        >
          <button class="btn-download mt-2">
              <!-- <i class="fas fa-chevron-left"></i> -->
              <!-- {{ $t("events.newEvent.back") }} -->
            {{ $t("qrAccess.activeDrivers.createBtn") }}
          </button>
        </router-link>
      </div>
      <div class="col-md-12">
        <v-server-table
          :columns="table_options.columns"
          :options="table_options.options"
          ref="driversTable"
        >
          <template v-slot:actions="props">
            <div class="actionsDrivers">
              <!-- Edit -->
              <router-link
                class="edit-btn"
                :to="{
                  name: 'Edit Driver',
                  params: {
                    id: props.row.id,
                    controlNumber: props.row.controlNumber,
                    edit: true
                    // edit: props.row
                  }
                }"
              >
                <i class="far fa-edit"></i>
              </router-link>

              <!-- Delete -->
              <i @click="deleteDriver(props)" class="far fa-trash-alt"></i>

              <!-- Detail -->
              <router-link
                class="edit-btn"
                :to="{
                  name: 'Driver Details',
                  params: {
                    id: props.row.id,
                    controlNumber: props.row.controlNumber,
                    data: props.row,
                    details: true
                  }
                }"
              >
                <i class="far fa-eye"></i>
              </router-link>
            </div>
          </template>
        </v-server-table>
      </div>
    </div>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/QRAccess.js";
const api = new API_SERVICE();

export default {
  data() {
    return {};
  },
  methods: {
    deleteDriver: async function(event) {
      console.log('computing ....', this.$refs.driversTable);
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.deleteDriver(event.row);
        this.$refs.driversTable.refresh();
        this.$store.commit("global/SET_LOADING", false);
        return resp;
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    downloadTable: async function(event) {
      const filterParams = this.$refs.driversTable.query;
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.downloadBusDriversTable(filterParams);
        let anchor = document.createElement("a");
        anchor.href = resp.url;
        anchor.target = "_blank";
        anchor.click();
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      }
    }
  },
  computed: {
    driversTable: function() {
      return this.$refs.driversTable;
    },
    table_columns: function() {
      return [
        "controlNumber",
        "name",
        "lastName",
        "mothersLastName",
        "companyName",
        "providerNumber",
        "actions"
      ];
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(
            `qrAccess.activeDrivers.table.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(column => column !== "actions");
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          resizableColumns: false,
          perPageValues: [25, 50, 100],
          // perPageValues: [2, 4, 6],
          perPage: 25,
          // perPage: 2,
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler")
          },

          requestAdapter: function(data) {
            const queries = {};
            queries.page = data.page - 1;
            queries.limit = data.limit;
            queries.query = data.query;
            return queries;
          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            try {
              const resp = await api.getAllDrivers(data);
              this.$store.commit("global/SET_LOADING", false);
              // this.$store.commit("global/SET_ALERT", {
              //   msg: "Data loaded successfuly",
              //   show: true,
              //   type: "success"
              // });
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              // this.$store.commit("global/SET_ALERT", {
              //   msg: `${error}`,
              //   show: true,
              //   type: "error"
              // });
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data: response.busDrivers,
              count: response.total
            };
          }
        }
      };
    }
  }
};
</script>

<style>
.btn-download {
  padding: 0.5rem 2rem;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 0px;
}
.actionsDrivers {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.actionsDrivers > *, button {
  cursor: pointer;
}
.actionsDrivers > .edit-btn {
  color: #000000;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  &:hover {
    color: #000000;
  }
}
.VueTables .dropdown {
  margin: 1rem 0;
}
.VueTables__columns-dropdown {
  float: initial !important;
}
.VueTables__columns-dropdown > button {
  color: #000 !important;
  background-color: transparent !important;
  border: 1px solid #000 !important;
  border-radius: 0 !important;
  padding: 5px 10px !important;
}
.VueTables .dropdown .dropdown-menu {
  padding: 1rem;
}
.VueTables .dropdown .dropdown-menu a {
  color: #000;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.VueTables .dropdown .dropdown-menu a > input {
  margin-right: 0.5rem;
}
</style>
